import { Component, OnInit } from '@angular/core';
import { MainService } from '../../Services/service.service';

@Component({
  selector: 'app-empty-page',
  templateUrl: './empty-page.component.html',
  styleUrls: ['./empty-page.component.css']
})
export class EmptyPageComponent implements OnInit {

  constructor(public service:MainService) { }

  ngOnInit() {
  }

}
